const heroContent = {
  form: [
    {
      title: 'Conheça agora a melhor oferta para você',
      ctaPath: 'basic-data',
      ctaLabel: 'Conhecer oferta',
      ctaTrackClick: 'btn:conhecer-oferta'
    }
  ],
  list: [
    {
      title: 'Antecipação do Saque-Aniversário',
      description:
        'Adiante até 7 saques do seu FGTS e não se preocupe com prestações mensais',
      imgMobile: {
        altMagalu: 'Foto de mulher sorrindo',
        altPartners: 'Foto de mulher sorrindo',
        alt: '',
        filenameMagalu: 'hero-fgts-mobile-new',
        filenamePartners: 'hero-fgts-partners-mobile',
        filename: 'hero-fgts-mobile-new'
      },
      imgDesktop: {
        altMagalu: 'Foto de mulher sorrindo',
        altPartners: 'Foto de mulher sorrindo',
        alt: '',
        filenameMagalu: 'fgts-banner-principal',
        filenamePartners: 'hero-fgts-partners-desktop',
        filename: 'fgts-banner-principal'
      }
    }
  ]
}

export default heroContent
